import type { SiteVariant } from '@layers/web/types/env.ts'
import type { CustomerServicePhone } from '@layers/web/constants/types/customer-service.ts'

const SWEDISH_CUSTOMER_SERVICE_PHONE_PATTERN = /(?:\+46[\s-]?|0)771[\s-]?15[\s-]?00[\s-]?00/g

const E164_PHONE_PATTERN = /^\+\d+$/

const SITE_VARIANT_CUSTOMER_SERVICE_PHONES: Record<SiteVariant, CustomerServicePhone> = {
  fi: {
    display: '+358 6 557 0886',
    e164: '+35865570886',
  },
}

export {
  SWEDISH_CUSTOMER_SERVICE_PHONE_PATTERN,
  E164_PHONE_PATTERN,
  SITE_VARIANT_CUSTOMER_SERVICE_PHONES,
}
